/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import {
  Input,
  Button,
  Avatar,
  Row,
  Col,
  Drawer,
  Space,
  Radio,
  Form,
  Skeleton,
  Empty,
} from "antd";
import BreadcrumbPageLayout from "Components/page-layouts/BreadcrumbPageLayout";
import { SearchOutlined } from "@ant-design/icons";
import "./contact.css";
import { Link } from "react-router-dom";
import { useBlustreamApiQuery, products } from "apiService/blustreamApi";
import SkeletonBlock from "commons/Skeleton/SkeletonBlock";
import { useHistory } from "react-router";

const { Search } = Input;

const Product = () => {
  const history = useHistory();

  const [productData, setProductData] = useState([]);
  const [addProductAttributeDrawer, setAddProductAttributeDrawer] =
    useState(false);
  const [form] = Form.useForm();
  const [searchValue, setSearchValue] = useState("");
  const [searchedProducts, setSearchedProducts] = useState([]);

  const AddonClose = () => {
    setAddProductAttributeDrawer(false);
  };

  const { data: allProducts, loading } = useBlustreamApiQuery(
    async (signal) => {
      const acc = [];
      let page = 0;
      while (true) {
        const resp = await products.list({ page, size: 100, signal });
        const content = resp?.content || [];
        acc.push(...content);
        if (resp?.page?.last || content.length === 0) break;
        page += 1;
      }
      return acc;
    },
    []
  );

  useEffect(() => {
    if (!allProducts) return;
    const mapped = allProducts.map((p) => ({
      pName: p?.name,
      key: p?.product_id,
    }));
    setProductData(mapped);
    setSearchedProducts(mapped);
  }, [allProducts]);

  const onProductSearch = (e) => {
    setSearchValue(e.target.value);
    let data = productData.filter((product) =>
      product.pName
        .toLowerCase()
        .includes(e.target.value?.trimStart()?.toLowerCase())
    );
    setSearchedProducts(data);
  };

  return (
    <>
      <BreadcrumbPageLayout crumbs={[{ label: "Products" }]}>
        <div>
          <div className="contactBox productBox">
            <div className="dataContent">
              <div className="tableHeader">
                <div className="products-header-titles">
                  <p className="manageButton">All Products</p>
                  <p className="products-header-subtitle">
                    Manage all your product details from this dashboard.
                  </p>
                </div>

                {loading ? (
                  <Skeleton.Button active style={{ width: 200 }} />
                ) : (
                  <div className="flexBox">
                    <div
                      style={{ display: "flex", marginRight: 10 }}
                      className="view-btns"
                    ></div>
                    <div style={{ position: "relative", marginRight: "10px" }}>
                      <Search
                        className="standard-searchbox"
                        prefix={
                          <SearchOutlined className="standard-searchbox-prefix" />
                        }
                        placeholder="Search names"
                        type="search"
                        value={searchValue}
                        onChange={(e) => onProductSearch(e)}
                        allowClear
                      />
                    </div>
                    {productData?.length > 0 && (
                      <Button
                        className="standard-button primary-orange-button"
                        type="secondary"
                        onClick={() => history.push("/product-mapping")}
                        ghost={false}
                      >
                        Map Products
                      </Button>
                    )}
                  </div>
                )}
              </div>

              <div>
                <div style={{ margin: "24px 21px", position: "relative" }}>
                  {loading ? (
                    <>
                      <Row gutter={[20, 20]}>
                        <SkeletonBlock style={{ width: 250 }} />
                        <SkeletonBlock style={{ width: 250 }} />
                        <SkeletonBlock style={{ width: 250 }} />
                        <SkeletonBlock style={{ width: 250 }} />
                      </Row>
                    </>
                  ) : (
                    <Row gutter={16} style={{}}>
                      {searchedProducts?.length > 0 ? (
                        searchedProducts.map((item) => {
                          return (
                            <Col
                              span={6}
                              lg={6}
                              md={6}
                              sm={24}
                              xs={24}
                              key={item.key}
                            >
                              <Link to={`/products/${item?.key}`}>
                                <div
                                  style={{
                                    background: "#F0F7FD",
                                    marginBottom: 20,
                                    borderRadius: "9px",
                                    display: "flex",
                                    flexDirection: "column",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    height: 250,
                                    width: "100%",
                                    padding: "0 16px",
                                  }}
                                >
                                  <Avatar size={100}>
                                    <span style={{ color: "black" }}>
                                      {item.pName[0].toUpperCase()}
                                    </span>
                                  </Avatar>
                                  <h3
                                    style={{
                                      marginTop: 10,
                                      marginBottom: 0,
                                      fontWeight: 600,
                                      color: "#252525",
                                      textAlign: "center",
                                      wordBreak: "break-word",
                                    }}
                                  >
                                    {item.pName}
                                  </h3>
                                </div>
                              </Link>
                            </Col>
                          );
                        })
                      ) : (
                        <>
                          <Row justify="center" style={{ width: "100%" }}>
                            <Col>
                              <Empty
                                image={Empty.PRESENTED_IMAGE_SIMPLE}
                                description="No Products"
                              />
                            </Col>
                          </Row>
                        </>
                      )}
                    </Row>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </BreadcrumbPageLayout>

        <Drawer
          width={430}
          title="Add new product attribute"
          placement="right"
          onClose={AddonClose}
          visible={addProductAttributeDrawer}
        >
          <Form
            form={form}
            className="product-attribute-form"
            layout="vertical"
          >
            <Form.Item label="Attribute Title" style={{ width: "100%" }}>
              <Input
                className="standard-input"
                placeholder="Enter attribute title"
              />
            </Form.Item>

            <Form.Item label="Attribute Title" style={{ width: "100%" }}>
              <Radio.Group>
                <Space direction="vertical">
                  <Radio value={1}>Text field</Radio>
                  <Radio value={2}>Date Selection</Radio>
                  <Radio value={3}>Multi-select dropdown</Radio>
                  <Radio value={4}>Single-select dropdown</Radio>
                </Space>
              </Radio.Group>
            </Form.Item>
          </Form>
          <div
            style={{
              position: "absolute",
              right: 0,
              bottom: 0,
              left: 0,
              width: "auto",
              borderTop: "1px solid #e9e9e9",
              fontSize: "18px",
              padding: "10px 16px",
              background: "#EFF4F9",
              textAlign: "right",
              display: "flex",
            }}
          >
            <Button
              className="standard-button tertiary-button"
              style={{ marginRight: 8, width: "48%" }}
              onClick={AddonClose}
            >
              Cancel
            </Button>
            <Button
              type="primary"
              style={{ width: "48%" }}
              htmlType="submit"
              className="standard-button primary-orange-button"
            >
              Add
            </Button>
          </div>
        </Drawer>
    </>
  );
};

export default Product;
